import { createSlice } from '@reduxjs/toolkit';

interface IHeartState {
  isOpen: boolean;
}

const initialState: IHeartState = {
  isOpen: false
};

const heartModalSlice = createSlice({
  name: 'heart-modal',
  initialState,
  reducers: {
    openHeartModal: state => {
      state.isOpen = true;
    },
    closeHeartModal: state => {
      state.isOpen = false;
    }
  }
});

export const { openHeartModal, closeHeartModal } = heartModalSlice.actions;
export const heartModalReducer = heartModalSlice.reducer;
